// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import FaceUploadLayout from "../../components/facesearch/FaceUploadLayout";
import {
  setSearchToken,
  setLoadedImage,
  uploadFile
} from "../../actions/faceActions";

import Image1 from "../../../../images/samples/Abdel_Nasser_Assidi_0002.jpg";
import Image2 from "../../../../images/samples/George_HW_Bush_0006.jpg";
import Image3 from "../../../../images/samples/George_P_Bush_0002.jpg";
import Image4 from "../../../../images/samples/George_W_Bush_0042.jpg";
import Image5 from "../../../../images/samples/George_W_Bush_0098.jpg";
import Image6 from "../../../../images/samples/Michael_Jackson_0002.jpg";
import Image7 from "../../../../images/samples/Michael_Jackson_0004.jpg";
import Image8 from "../../../../images/samples/Michael_Jackson_0006.jpg";
import Image9 from "../../../../images/samples/Prince_Harry_0002.jpg";
import Image10 from "../../../../images/samples/Queen_Elizabeth_II_0012.jpg";
import Image11 from "../../../../images/samples/The-cast-of-Les-Miserables.jpg";

type FaceUploadPropsType = {
  faceSearch: { [key: string]: * },
  setImageError: Function,
  setStep: Function,
  actions: {
    setSearchToken: Funciton,
    setLoadedImage: Function,
    uploadFile: Function
  }
};

class FaceUpload extends Component<*> {
  render(): * {
    return (
      <FaceUploadLayout
        faceSearch={this.props.faceSearch}
        setSearchToken={this.props.actions.setSearchToken}
        setLoadedImage={this.props.actions.setLoadedImage}
        uploadFile={this.props.actions.uploadFile}
        setImageError={this.props.setImageError}
        setStep={this.props.setStep}
        samples={[
          Image1,
          Image2,
          Image3,
          Image4,
          Image5,
          Image6,
          Image7,
          Image8,
          Image9,
          Image10,
          Image11
        ]}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  faceSearch: state.v3account.faceSearch
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { setSearchToken, setLoadedImage, uploadFile },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FaceUpload);
